import Model from '../../model'

export default class Action extends Model {
    resource()
    {
        return 'actions'
    }

    completed() {
        let endpoint = `${this.baseURL()}/completed-action`

        return this.request({
            method: 'POST',
            url: endpoint,
            data: {action_id: this.id}
        }).then(response => {
            return response.data.data
        })
    }

    uncompleted() {
        let endpoint = `${this.baseURL()}/completed-action/${this.id}`

        return this.request({
            method: 'DELETE',
            url: endpoint,
        }).then(response => {
            return response.data.data
        })
    }
}
